import { createBlock as o, openBlock as i, mergeProps as t, withCtx as r, createVNode as d } from "vue";
import l from "../../video-player/video-player.vue.js";
import s from "../utils/card-props.vue.js";
import n from "./card.vue.js";
import { themeProp as c } from "../../../composables/useTheme.js";
import { screenProp as m } from "../../../utils/utilsScreen.js";
/* empty css                     */
import f from "../../../_virtual/_plugin-vue_export-helper.js";
import v from "../../../utils/validators/video-player.js";
const p = "DsCardWithVideo", h = /* @__PURE__ */ Object.assign({
  name: p
}, {
  __name: "card-with-video",
  props: {
    ...s,
    ...c,
    ...m,
    video: {
      type: Object,
      required: !0,
      validator: v
    }
  },
  setup(e) {
    return (a, b) => (i(), o(n, t({
      class: ["ds-card-with-video", { "ds-card-with-video--contained": a.contained }]
    }, a.$props, { "data-j-card": "" }), {
      media: r(() => [
        d(l, {
          thumbnail: e.video.thumbnail,
          "aria-label-play": e.video.ariaLabelPlay,
          "aria-label-close": e.video.ariaLabelClose,
          "self-hosted": e.video.selfHosted,
          extension: e.video.extension,
          src: e.video.src,
          title: e.video.title,
          screen: a.screen,
          "data-j-video": ""
        }, null, 8, ["thumbnail", "aria-label-play", "aria-label-close", "self-hosted", "extension", "src", "title", "screen"])
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), g = /* @__PURE__ */ f(h, [["__scopeId", "data-v-a14073fa"]]);
export {
  g as default
};
